/* ----------------------------------------------------------- */
/*          AIO CMS JS Library - © Aiomax Group 2024           */
/* ----------------------------------------------------------- */
/**
 * Import objects
 */
import {polaris, slideshow} from "./modules/config";
import {websiteNav, scrollHandler} from "./modules/core";


/**
 * AIO object
 */
const AIO = {
    Polaris:       polaris,
    Slideshow:     slideshow,
    websiteNav:    websiteNav,
    scrollHandler: scrollHandler
}


/**
 * Export default
 */
export default AIO;